import React from "react";
import InputTextField from "../../Views/inputtextfield/InputTextField";

import ManagePropertyDropdown from "../manageproperty/ManagePropertyDropdown";
import Profile from "../profile/Profile";
import { useState } from "react";

const AppHeader = () => {
  const [name, setName] = useState('')
  return (
    <>
      <div className="header-wrapper header-bg-color header-position">
        <div className="header__content__wrapper">
          <ManagePropertyDropdown />
          <Profile />
        </div>
      </div>
    </>
  );
};

export default AppHeader;
